import { render } from "./SimpleOptionSelectorField.vue?vue&type=template&id=71d812a3&scoped=true"
import script from "./SimpleOptionSelectorField.vue?vue&type=script&lang=js"
export * from "./SimpleOptionSelectorField.vue?vue&type=script&lang=js"

import "./SimpleOptionSelectorField.vue?vue&type=style&index=0&id=71d812a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d812a3"]])

export default __exports__